import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { EventsModel, UserMonthEvents, UserMonthlyEvents } from 'src/app/services/user-events/models/user-events.model';
import { UserEventsService } from 'src/app/services/user-events/user-events.service';
import { CustomerType } from 'src/app/models/client-configuration';
import { ConfigService } from 'src/app/services/config.service';
import { SearchModel } from 'src/app/models/search-model';
import { Router } from '@angular/router';

@Component({
  selector: 'user-events',
  templateUrl: './user-events.component.html',
  styleUrls: ['./user-events.component.scss'],
})
export class UserEventsComponent implements OnInit {
  userEvents: UserMonthlyEvents;
  customerType: CustomerType;
  currentDay: string;
  section = 'events';
  indexEventToday: number;

  isLoading = true;

  constructor(
    private userEventsService: UserEventsService,
    private configService: ConfigService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.userEventsService.userMonthlyEvents().subscribe({
      next: (response) => {
        this.userEvents = response;
        this.isLoading = false;
        this.scrollToNearestDay(response.monthEvents);
      },
      error: () => (this.isLoading = false),
    });
    this.customerType = this.configService.customerType;
  }

  isToday(checkDate: string) {
    const date = new Date(checkDate);
    const today = new Date();
    return date.toDateString() === today.toDateString();
  }


  exploreLearningExperiences() {
    const model = new SearchModel();
    model.explore = true;

    this.router.navigate(['/results'], {
      queryParams: model.toRequestLearningExperiences(),
    });
  }

  private scrollToNearestDay(monthEvents: UserMonthEvents[]) {
    const dayEvents: EventsModel[] = [];
    monthEvents.forEach((me) => me.dayEvents.forEach((de) => dayEvents.push(de)));
    const elementID = this.getClosestDateAmountEvents(dayEvents);
    if (elementID == null) {
      return;
    }

    setTimeout(() => {
      const element = document.getElementById(elementID);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 1000);
  }

  private getClosestDateAmountEvents(events: EventsModel[]): string {
    const now = new Date();

    for (const event of events) {
      if (new Date(event.date).toDateString() === now.toDateString()) {
        return event.date;
      }
    }

    const futureEvents = events.filter((obj) => new Date(obj.date) > now);
    if (futureEvents.length === 0) {
      return null;
    }

    futureEvents.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
    return futureEvents[0].date;
  }
}
